
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gk9OFgoo9LQnTTDrx55XAtVtEpVCJ1jehI9a3IjJ7iV8Meta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexDh0qXUwiZu8llh9Rni4GBjPf_45E75ROEhv1jSDzd62u8Meta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchWIrfDloPgkaWy9rdv0sf3k83wWnWi_9b3Iy0o7sDe_sMeta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexiQN0UNmR6XC9H4giV_VT0hV9PW_45Kssmy9HFTDjsz2egMeta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93gKQw64u8UpPDD9W70l8icAfOi93ASEhQVO6AgO9tmqUMeta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexsTpnVlqum_opVP_Y7_vArHoMguS2sVWfI840DIb3SsIMeta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93gU7JTnTANTpGV3Ksg78LOPAg47Pm1t1IgUahq9cDmiUMeta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexpJS1pQaIf6phoPUrTicdpyce1YbQLacAZzmCqKcFMxoMeta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_934XNo6a52jflSmVMpfzCzDpGxR19UFxfLZSLdM8x1rM8Meta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexDuECtZBr9Vd1mKukqpO6CIa97QmtpJJskaBz8Zal8koMeta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexPK01tFxzXvylXaLsMIVUVWI4CQmihDN5shKxgOEOLWYMeta } from "/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexsTpnVlqum_opVP_Y7_vArHoMguS2sVWfI840DIb3SsIMeta || {},
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexpJS1pQaIf6phoPUrTicdpyce1YbQLacAZzmCqKcFMxoMeta || {},
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexDuECtZBr9Vd1mKukqpO6CIa97QmtpJJskaBz8Zal8koMeta || {},
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexPK01tFxzXvylXaLsMIVUVWI4CQmihDN5shKxgOEOLWYMeta || {},
    component: () => import("/codebuild/output/src4120852717/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]